import {
  useContext,
  createContext,
  useState,
  ReactNode, useMemo,
} from "react";

export interface WrapperContextInterface {
  increment(): void;
  decrement(): void;
  index: number;
  forceSetIndex(value: number): void;
  setMaxIndex(value: number): void;
}

const defaultState = {
  increment: () => {},
  decrement: () => {},
  index: 0,
  forceSetIndex: (value: any) => {},
  setMaxIndex: (value: any) => {},
};

const WrapperContext = createContext(defaultState);

export function useWrapper() {
  return useContext(WrapperContext);
}

type WrapperProviderProps = {
  children: ReactNode;
};

export default function WrapperProvider({ children }: WrapperProviderProps) {
  const [index, setIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(1);

  const value = useMemo(() => ({
    increment: () => setIndex(v => v < maxIndex ? v + 1 : v),
    decrement: () => setIndex(v => v > 0 ? v - 1 : v),
    index,
    forceSetIndex: (value: number) => setIndex(value),
    setMaxIndex,
  }), [index, maxIndex]);

  return (
    <WrapperContext.Provider value={value}>{children}</WrapperContext.Provider>
  );
}
